
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups",
      function () {
        return require("private-next-pages/groups/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups"])
      });
    }
  